// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.IsDisable[data-v-245a5833]{\r\n  background-color:gray;\n}\r\n/*#tblMain{*/\r\n/*  width: 1000px;*/\r\n/*}*/\r\n/*.btn{*/\r\n/*  color: white !important;*/\r\n/*  margin: 5px;*/\r\n/*  width: 40px;*/\r\n/*}*/\r\n", ""]);
// Exports
module.exports = exports;
